import { useState, useEffect, useCallback } from 'react'

const STORAGE_KEY = 'fresh_market_favorites'

function loadFromStorage(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

function saveToStorage(ids: string[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids))
  } catch {
    // storage full or unavailable — fail silently
  }
}

export function useFavorites() {
  const [favoriteIds, setFavoriteIds] = useState<string[]>(loadFromStorage)

  // Sync to localStorage on every change
  useEffect(() => {
    saveToStorage(favoriteIds)
  }, [favoriteIds])

  const isFavorite = useCallback(
    (id: string) => favoriteIds.includes(id),
    [favoriteIds]
  )

  const toggle = useCallback((id: string) => {
    setFavoriteIds(prev =>
      prev.includes(id) ? prev.filter(fid => fid !== id) : [...prev, id]
    )
  }, [])

  const clear = useCallback(() => setFavoriteIds([]), [])

  const count = favoriteIds.length

  return { favoriteIds, isFavorite, toggle, clear, count }
}
